import { render, staticRenderFns } from "./NotificationContainerSmall.vue?vue&type=template&id=793a05a8&scoped=true&"
import script from "./NotificationContainerSmall.vue?vue&type=script&lang=js&"
export * from "./NotificationContainerSmall.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContainerSmall.vue?vue&type=style&index=0&id=793a05a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a05a8",
  null
  
)

export default component.exports